<template lang="pug">
  div.map-container.geo.forecasts.map-treads
    router-view

    div.toolbar
      div.line
        h1.title {{$translate('Моделирование')}}

        e-suggestion(
        placeholder=" "
        @selectItem="selectItemOnMapSearch"
        name="q"
        :model="suggestionMapSearch"
        :useInnerSearch="true"
        :options="suggestionMapSearchOptions"
        ).search
        div.checked-new
          label.optimize
            input.new-checkbox(type="checkbox" v-model="optimizeThreads")
            span Оптимизировать
        div.checked-new
          label.new-check
            input.new-checkbox(type="checkbox" v-model="showDeleted")
            span Показать удаленное
        div.actions-panel
          button.actions-panel__button.btn-download(@click="getAndSaveScreenshot")
          button.actions-panel__button.btn-download.download-kml(@click="getAndSaveKML") KML
          button.actions-panel__button.btn-download.download-kml(@click="getAndSaveShapefile") Shapefile

    map-mapping-legend(
      v-if="showModelTariffs"
      :mappingCurrentLegend="{title: 'Тарифы'}"
      :legendItems="tariffLegendRegion.data ? tariffLegendRegion.data : []"
      style="left: 10px !important; bottom: 89px;"
    )
    div(style="z-index:9").map-year-track.mapYearTrack
      div(
      v-if="yearList"
      ).date Дата:
        span.year {{year}}
          div.track-wrapper
            span.year-start {{min}}
            div.track
              el-slider(
              style="width:100%;"
              :min="min"
              :max="max"
              :value="year"
              @input="yearHandler"
              :step="1"
              show-stops
              )
            span.year-start {{max}}
            button(v-if="!$store.getters.isGuest").btn-edit(@click="popUpMapShow('showMapPopup',['showMapPopupCreate', 'showMapPopupDelete'])")
            button(v-if="!$store.getters.isGuest").btn-add(@click="popUpMapShow('showMapPopupCreate',['showMapPopup', 'showMapPopupDelete'])")

            el-tooltip(placement="top")
              div(slot="content")
                p При обновлении потоков на схеме моделирования отобразятся объекты
                p обращения с отходами и потоки к ним, отображенные на схеме потоков
                p независимо от года
              el-button(v-if="!$store.getters.isGuest" ).btn-delete( @click="popUpMapShow('showMapPopupDelete',['showMapPopupCreate', 'showMapPopup'])")

            el-tooltip(placement="top")
              div(slot="content")
                p Перерасчет тарифа
              el-button(v-if="!$store.getters.isGuest").btn-tariff(style="padding: 12px 8px important!;" @click="refreshTariffs()")

      div(
      v-else
      ).date
        span.year
          div.track-wrapper
            span.year-start
            div.track {{$translate('Прогнозы не найдены')}}
            span.year-end

      // лежит в \src\app\geo\components\map-year-track-popup.vue
      map-year-update(
      :openedStateVariable="this.popups.showMapPopup"
      @closeForm="popUpUpdateClose"
      )
      map-year-create(
      :showForm="this.popups.showMapPopupCreate"
      @closeForm="popUpCreateClose"
      )
      map-year-delete(
      :openedStateVariable="this.popups.showMapPopupDelete"
      @closeForm="popUpDeleteClose"
      )

    div.new-map
      div(ref="map" v-once).bigmap#map
        // map-icons

      map-legend(
        :showRemoved="true"
        @showAll="showAll"
        @showTKOLine="showTKOLine"
        @showOtherLine="showOtherLine"
        @showMixedLine="showMixedLine"
        @showAllThreads="showAllThreads"
        @showModelTariffs="showModelTariffsHandle"
        @showStatusPlan="showStatusPlan"
        @showStatusActive="showStatusActive"
        )
</template>

<script>
  import {forecastMixin} from "./mixins/forecast-mixin"

  import MapLegend from './components/map-forecasts-legend'
  import {map as mapEndpoints} from '../../api/api-endpoints.js'
  import year from '../../utils/year.js'
  import MapYearUpdate from "./components/map-year-update.vue";
  import MapYearCreate from "./components/map-year-create.vue";
  import MapYearDelete from "./components/map-year-delete.vue"
  import MapMappingLegend from "./components/map-mapping-legend";

  export default {
    name: 'forecasts',
    mixins: [forecastMixin],
    components: {
      MapYearUpdate,
      MapLegend,
      MapMappingLegend,
      MapYearCreate,
      MapYearDelete
    },
    beforeCreate() {
      this.$store.commit('preloaderOn', true)
    },
    methods: {
      refreshTariffs(){
        this.$store.dispatch('createModel', {
          url: mapEndpoints.heatMapRefreshTariffs(this.$route.query.year),
          data: {}
        }).then(r=>{
          this.$store.dispatch('updateUrlEndpoint', {
            endpoint: this.getMapModelingRegionTariff()
          })
        }).then(() => {
          this.refreshMap()
        })
      },
      getMapTkoObjectsEndpoint () {
        return mapEndpoints.objectForThreads()
      },
      getMapModelingRegionTariff(year){
        return mapEndpoints.mapModelingRegionTariff(year)
      },
      getThreadEndpoint (route) {
        if (!route.query.year) {
          route.query.year = year.getCurrentYear()
        }
        return mapEndpoints.threadsByYear(route)
      },
      getSettlementEndpoint (route) {
        return mapEndpoints.settlements(route)
      },
      getGarbageSourceEndpoint (route) {
        let routeChanged = Object.assign({}, route)
        if (routeChanged.query.optimizeThreads) {
          delete routeChanged.query.optimizeThreads
        }
        return mapEndpoints.garbageSources(routeChanged)
      },
      getDownloadKMLEndpoint () {
        return mapEndpoints.downloadKML(this.year)
      },
      getDownloadShapefileEndpoint () {
        return mapEndpoints.downloadShapefile(this.year)
      },
      getTariffLegend(){
        return mapEndpoints.heatMapTariffsSettings()
      }
    },
  }
</script>
